import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';

const SelectViewContainer = styled.div`
  background: #242424;
  border-radius: ${32 * Screen.widthRatio}px;
  height: ${456 * Screen.widthRatio}px;
`;

export default SelectViewContainer;
